import api from 'api';
import useUndoActions from 'hooks/useUndoActions';
import { SOFT_SIGNALS, SoftSignalPayload } from 'models/Lead';
import { useCallback } from 'react';

export default function useBuyerPulseCheck(
  leadId: string,
  onPulseCheckSuccess: (
    withdrawInterest: boolean,
    isConfirmingInterest: boolean,
  ) => void,
) {
  const { isUndoAvailable, setUndoTimeout, clearUndoTimeout } =
    useUndoActions();

  const onUndo = useCallback(async () => {
    try {
      clearUndoTimeout();
      await api.portfolio.buyer.softSignalReactUndo(leadId);
    } catch {
      return;
    }
  }, [clearUndoTimeout, leadId]);

  const onSubmit = useCallback(
    async (
      { softSignal, withdrawInterest, message }: SoftSignalPayload,
      isSkipPressed = false,
    ) => {
      try {
        clearUndoTimeout();
        await api.portfolio.buyer.softSignalReact(leadId, {
          softSignal,
          withdrawInterest,
          message: isSkipPressed ? undefined : message,
        });
        setUndoTimeout(() =>
          onPulseCheckSuccess(
            withdrawInterest,
            softSignal === SOFT_SIGNALS.LIKE,
          ),
        );
      } catch (e) {
        return;
      }
    },
    [clearUndoTimeout, leadId, onPulseCheckSuccess, setUndoTimeout],
  );

  return { isUndoAvailable, onUndo, onSubmit };
}
